<template>
<div class="chapter">
<div class="inner_page">
<p class="ind" style="margin-top:20px;"><a id="page11"></a><a id="page12"></a><a id="start"></a><a id="page13"></a><a id="page14"><i>No pseudonyms have been used in this book, no composite characters. Everyone who appears in this book is real. They have contributed their stories generously.</i></a></p><a id="page14">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-intro.vue?80b698fe